import { FC, ReactElement } from 'react';
import { m } from 'framer-motion';
import Info from '@components/Icons/Info';
import classNames from 'classnames';
import usePopover from '@/hooks/usePopover';
import { createPortal } from 'react-dom';

import s from './Tooltip.module.scss';

const Tooltip: FC<{
  text: string;
  id?: string;
  alignment?: 'bottom-left' | 'bottom-center' | 'bottom-right';
  children?: ReactElement;
  classNameWrapper?: string;
  classNameTooltip?: string;
}> = ({ text, id, alignment, children, classNameWrapper, classNameTooltip }) => {
  const { isOpen, setIsOpen, menuRef, triggerRef } = usePopover('bottom-center');
  return (
    <div
      className={classNames(s.tooltipWrapper, classNameWrapper)}
      style={{ alignItems: (alignment === 'bottom-left' && 'flex-start') || (alignment === 'bottom-right' && 'flex-end') || 'center' }}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        className={s.trigger}
        ref={triggerRef as unknown as React.RefObject<HTMLDivElement>}
        {...(!children && {
          style: {
            height: 44,
            width: 44,
          },
        })}
      >
        {children || <Info weight="fill" size={20} />}
      </div>
      {isOpen && createPortal(
        <m.div
          role="tooltip"
          ref={menuRef}
          id={(id && `${id}-describer`) || undefined}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          className={classNames((alignment === 'bottom-left' && s.tooltipLeft) || (alignment === 'bottom-right' && s.tooltipRight) || s.tooltip, classNameTooltip)}
        >
          {text}
        </m.div>,
        document.body,
      )}
    </div>
  );
};

export default Tooltip;
